import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Typography, ProgressBar, createTheme, ThemeProvider
} from '@one-thd/sui-atomic-components';
import { StarFilled } from '@one-thd/sui-icons';

const theme = createTheme({
  palette: {
    background: {
      inverse: 'tangerine-400'
    }
  }
});

export const Histogram = ({
  clickableFilters,
  onClick,
  onFilterChange,
  percentage,
  ratings,
}) => {

  const total = ratings.reduce((acc, rating) => acc + rating.count, 0);

  const getPercentageRating = (countOfStarReviews) => {
    return (parseInt(countOfStarReviews, 10) / parseInt(total, 10)) * 100;
  };

  const histogramBarClick = (ratingValue, count) => {
    if (clickableFilters && count > 0) {
      if (onFilterChange) {
        onFilterChange(ratingValue);
      }
      if (onClick) {
        onClick(ratingValue);
      }
    }
  };

  return (
    <div className="sui-flex sui-flex-col sui-gap-2 sui-w-full" data-component="Histogram">
      {ratings
        .sort((i, n) => n.ratingValue - i.ratingValue)
        .map(({ count, ratingValue }) => {
          const percentageRating = getPercentageRating(count);
          const applyClickableClass = clickableFilters && count !== 0;
          const clickHandler = () => histogramBarClick(parseInt(ratingValue, 10), count);
          const countClass = classNames('sui-w-10', {
            'hover:sui-cursor-pointer hover:sui-underline': applyClickableClass
          });
          const btnWrapperClass = classNames('sui-w-full', {
            'hover:sui-cursor-pointer': applyClickableClass,
          });

          return (
            <div
              key={ratingValue}
              className="sui-flex sui-flex-row sui-items-center sui-gap-2"
              onClick={clickHandler}
              role="presentation"
            >
              <div className="sui-flex sui-gap-1">
                <Typography variant="body-xs">{ratingValue}</Typography>
                <StarFilled size="small" color="brand" />
              </div>

              <div className={btnWrapperClass}>
                <ThemeProvider theme={theme}>
                  <ProgressBar
                    value={percentageRating}
                  />
                </ThemeProvider>
              </div>

              <div className={countClass}>
                <Typography variant="body-xs" align="right">
                  {percentage ? `${parseInt(percentageRating, 10)}%` : count}
                </Typography>
              </div>

            </div>
          );
        })}
    </div>
  );
};

Histogram.propTypes = {
  clickableFilters: PropTypes.bool,
  /** Function when bar is clicked */
  onClick: PropTypes.func,
  onFilterChange: PropTypes.func,
  /** display percentage value instead of count */
  percentage: PropTypes.bool,
  /** Histogram bar label and number of star ratings to calculate % */
  ratings: PropTypes.arrayOf(
    PropTypes.shape({
      count: PropTypes.number,
      ratingValue: PropTypes.number,
    })
  )
};

Histogram.defaultProps = {
  clickableFilters: false,
  onClick: null,
  onFilterChange: null,
  percentage: false,
  ratings: [],
};
